import React from 'react';
import "./Pill.css";
import { Box, Typography } from '@mui/material';

// This Component takes in a prop of 'type' to have dynamic color and styled. 
// The types so far are as follows : 

// "Success",
// "Normal",
// "Error"
// "Warning"

export const Pill = ({
    type = '',
    bgColor = '',
    text = '',
    bold = 100,
    sx = {},
}) => (
    <Box
        className={`${type} pillContainer ${sx ? '' : 'flex'} ${bgColor ? 'HasBG' : ''}`}
        sx={{ backgroundColor : bgColor, ...sx }}
    >
        <Typography className={`pillText ${type}-color`} style={{ fontWeight: bold, alignContent: 'center' }}>
            {text && text.toUpperCase()}
        </Typography>
    </Box>
);
